<div class="ng-box">
  <div class="container">
    <div class="row" *ngIf="partners">
      <div class="col-12 align-self-center text-center text-sm-left">
        <div class="container">
          <h3>{{ productName | translate }}</h3>
          <div *ngFor="let partner of partners; let partnerIndex = index;" class="partner-form-wrapper">
            <div>
              <p>{{ 'Person' | translate }} {{ newStartPersonsNumbering + partnerIndex }}:</p>
            </div>
            <app-partner-form [(partner)]='partners[partnerIndex]'
              (eventFormValid)="partnerFormState(partnerIndex, true)"
              (eventFormInvalid)="partnerFormState(partnerIndex, false)" [showPartnerTitle]="false" [showGender]="false"
              [showZip]="false" [isChild]="!showEmail" [showPartnerNames]="showPartnerNames" [easyMode]="showBirthdayForm"
              [showPhone]="showPhone" [showAddress]="showAddress">
            </app-partner-form>
            <hr *ngIf="partners.length > partnerIndex + 1" class="mw-100" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
